import * as React from "react";
import { connect } from "react-redux";
import SettingRow from "../../components/SettingRow/SettingRow";
import { Container, Image, Icon } from "semantic-ui-react";
import { State } from "../../reducers";
import { fetchUserProfile } from "../../actions/settings.actions";
import "./ViewSettingsProfile.css";
import { withTranslation, WithTranslation } from "react-i18next";

interface ViewSettingsProfileProps extends WithTranslation {
    user: any;
    token: string;
    dispatch: any;
}

const mapStateToProps = (state: State) => {
    return { user: state.authentication.user, token: state.authentication.token };
};

class ViewSettingsProfile extends React.Component<ViewSettingsProfileProps, {}> {
    componentDidMount() {
        if (this.props.user?.id) {
            this.props.dispatch(fetchUserProfile(this.props.user.id));
        }
    }

    render() {
        const user = this.props.user;
        if (!user) {
            return <Container className="profile-settings" style={{ minHeight: '150px' }} />;
        }

        let firstName = user.firstName || "";
        let lastName = user.lastName || "";
        let weight = user.weight || 0;

        const name: string = firstName + " " + lastName;
        const profilePicture = user.imageUrl ? 
            <Image src={user.imageUrl} className="profile-picture" circular={true} /> : 
            <Icon name="user" className="profile-picture" circular={true} />;
        return (
            <Container className="profile-settings">
                <SettingRow title={this.props.t('profile.subPicture')} content={profilePicture} />
                <SettingRow title={this.props.t('profile.subName')} content={name} />
                <SettingRow title={this.props.t('profile.subWeight')} content={weight} />
            </Container>
        );
    }
}

export default withTranslation('settings')(connect(mapStateToProps)(ViewSettingsProfile));
